import { type FC } from "react";

import { Card, CardRowSimple, type GridCard, Tag, TagIntent } from "widgets";

import style from "../../core/cards/styles/Card.module.scss";

import { type Project } from "../../../graphql.js";
import { getProjectLabel, replaceProjectTermWithSystemSetting } from "../../../redux/modules/config.js";

export interface ICapabilitiesCardProps extends GridCard {
  project: Project;
}

const CapabilitiesCard: FC<ICapabilitiesCardProps> = ({ project }) => {
  if (!project) {
    return null;
  }

  return (
    <Card key="capabilities-info-card" title={`${getProjectLabel(true, false)} Settings`}>
      {Object.values(project.capabilities).map(({ enabled, capability }) => (
        <CardRowSimple label={replaceProjectTermWithSystemSetting(capability.name)} key={`capability-${capability.id}`}>
          {replaceProjectTermWithSystemSetting(capability.description)}
          <div className={style.tags_list}>
            <Tag intentColor={enabled ? TagIntent.Success : TagIntent.Danger}>{enabled ? "Enabled" : "Disabled"}</Tag>
          </div>
        </CardRowSimple>
      ))}
    </Card>
  );
};

export { CapabilitiesCard };
